import { TFunction } from 'react-i18next';

import * as api from '../../../api';

import { EditEmergencyContactValues } from './EmergencyContactsModal/schema';

const calculatePhoneNumberChanges = ({
  newContact,
  previousContact,
}: {
  newContact: api.Previsit.PatientEmergencyContact;
  previousContact: api.Previsit.PatientEmergencyContact;
}) => {
  let updates = 0;
  const [newContactNumber, newContactType] = newContact.cellPhoneNumber
    ? [newContact.cellPhoneNumber, api.Common.PhoneNumberKind.Cell]
    : [newContact.homePhoneNumber, api.Common.PhoneNumberKind.Home];

  const [previousContactNumber, previousContactType] =
    previousContact.cellPhoneNumber
      ? [previousContact.cellPhoneNumber, api.Common.PhoneNumberKind.Cell]
      : [previousContact.homePhoneNumber, api.Common.PhoneNumberKind.Home];

  if (newContactType !== previousContactType) {
    updates += 1;
  }

  if (newContactNumber !== previousContactNumber) {
    updates += 1;
  }
  return updates;
};

export const maybeSaveAsNew = (args: {
  newContact: api.Previsit.PatientEmergencyContact;
  previousContact: api.Previsit.PatientEmergencyContact;
}) => {
  const { newContact, previousContact } = args;
  const fields = Object.keys(newContact) as Array<
    keyof api.Previsit.PatientEmergencyContact
  >;

  let updates: number = (
    fields.filter(
      (field: keyof api.Previsit.PatientEmergencyContact) =>
        field !== 'status' &&
        field !== 'cellPhoneNumber' &&
        field !== 'homePhoneNumber' &&
        newContact[field] !== previousContact[field],
    ) as Array<keyof api.Previsit.PatientEmergencyContact>
  ).length;

  updates += calculatePhoneNumberChanges({
    newContact,
    previousContact,
  });

  return updates;
};

export const buildEmergencyContact = (values: EditEmergencyContactValues) => {
  const {
    firstName,
    lastName,
    cellPhoneNumber,
    homePhoneNumber,
    rank,
    emergencyContactRelationshipToPatient,
    patientRelationshipToEmergencyContact,
    status,
    isMobile,
  } = values;

  const contactNumber = isMobile
    ? {
        cellPhoneNumber,
        homePhoneNumber: null,
      }
    : {
        cellPhoneNumber: null,
        homePhoneNumber,
      };
  return {
    firstName: firstName.trim(),
    lastName: lastName.trim(),
    ...contactNumber,
    rank,
    emergencyContactRelationshipToPatient,
    patientRelationshipToEmergencyContact,
    status,
  };
};

export const generateTranslatedErrorMessage =
  (t: TFunction) => (errorTypeIntlKey: string, fieldNameIntlKey: string) => {
    return t(errorTypeIntlKey, {
      fieldName: t(fieldNameIntlKey, { ns: 'common' }),
    });
  };
